export { default } from './InputsErrorText';
